import { Dispatch } from 'react';
import {
  ParameterAward,
  ParameterItem,
  ParameterPaginateList,
  ParameterResultListParam,
} from '../types/parameter-setting';
import { forEach } from 'lodash';
import { getDayEnd, getDayStart } from 'src/app/common/utils';
import { apiClient, apiErrorHandler , ADMIN_URL } from 'src/app/common/network';

export type UpdateParameterBody = {
  awards: ParameterAward[];
};

const parameterEndpoint = '/simulation/parameter-setting';

export const fetchParameterResultList = async (
  params: ParameterResultListParam,
  sortKeys: { key: string; value?: string }[],
  dispatch?: Dispatch<any>,
): Promise<ParameterPaginateList> => {
  let queryPath = `${ADMIN_URL}${parameterEndpoint}?`;

  forEach(params, (param, key) => {
    if (typeof param === 'object') {
      if (param) {
        if (key.includes('From')) {
          queryPath += `${key}=${getDayStart(param).toISOString()}&`;
        }
        if (key.includes('To')) {
          queryPath += `${key}=${getDayEnd(param).toISOString()}&`;
        }
      }
    } else {
      queryPath += param ? `${key}=${param}&` : '';
    }
  });

  forEach(sortKeys, (sortParams, key) => {
    if (sortParams.value) {
      const sortValue = sortParams.value === 'asc' ? 'ascending' : 'descending';
      if (key === 0) {
        queryPath += `${sortParams.key}=${sortValue}&`;
      } else {
        queryPath += `${sortParams.key}=${sortValue}`;
      }
    }
  });

  if (!queryPath.includes('Sort')) queryPath += `lastUpdateDateSort=descending`;

  return apiClient
    .get<ParameterPaginateList>(queryPath)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const fetchParameterItem = async (id: string, dispatch?: Dispatch<any>): Promise<ParameterItem> => {
  return apiClient
    .get<ParameterItem>(`${ADMIN_URL}${parameterEndpoint}/${id}`)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const updateParameterItem = async (
  id: string,
  body: UpdateParameterBody,
  dispatch?: Dispatch<any>,
): Promise<void> => {
  return apiClient
    .put<void>(`${ADMIN_URL}${parameterEndpoint}/${id}`, body)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};
